import { render, staticRenderFns } from "./HelpScreen.vue?vue&type=template&id=b4d0035a&"
import script from "./HelpScreen.vue?vue&type=script&lang=js&"
export * from "./HelpScreen.vue?vue&type=script&lang=js&"
import style0 from "./HelpScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports